module.exports = __webpack_public_path__ + "img/GitHub.97eb0bc6.png";